/**
 * Initial State for DbBrowser Redux Store
 * Manages database operations state including local and server databases
 */

const Initial_State = {
    // Local database groups and databases
    dbGroups: [],
    databases: [],
    
    // Server-accessible items
    serverDatabases: [],
    serverDbGroups: [],
    
    // User name mappings for access control display
    userNames: {}, // { uid: { name: string, email: string } }
    
    // Loading and operation states
    loading: {
        dbGroups: false,
        databases: false,
        accessibleItems: false,
        syncCheck: false,
        userNames: false
    },
    
    // Operation in progress tracking
    operations: {
        pushing: null,      // ID of item being pushed to server
        downloading: null,  // ID of item being downloaded from server
    },
    
    // Error tracking
    errors: {
        dbGroups: null,
        databases: null,
        accessibleItems: null,
        syncCheck: null,
        push: null,
        download: null,
        userNames: null
    },
    
    // Yjs real-time sync status (per database)
    yjsSyncStatus: {}, // { databaseId: 'synced' | 'syncing' | 'error' | 'offline' }
    yjsPendingChanges: {}, // { databaseId: number (count) }
    
    // Last sync timestamp
    lastSyncCheck: null,
};

export default Initial_State;
